    
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="resources"
      disable-pagination
      :loading="isLoading"
      hide-default-footer
      :hide-default-header="isMobile"
      height="300px"
      dense
      class="elevation-1"
    >
    </v-data-table>
  </div>
</template>

<script>
import EasyPlanClient from "../../../utils/EasyPlanClient";

export default {
  props: ["resourcesType", "evento" ],
  data: () => ({
    resources: [],
    isMobile:false,
    isLoading:false,
    headers: [{ text: "Descrizione", value: "descrizione" }],
  }),

  created() {
    this.checkIfIsMobile();
    switch (this.resourcesType) {
      case "Uomo":
        this.loadWorkers();
        break;
      case "Mezzo":
        this.loadVehicles();
        break;
      case "Attrezzatura":
        this.loadEquipment();
        break;
    }
  },
  watch: {
    evento: function (value, old) {
      this.event_Changed(value);
    },
  },
  mounted(){
    this.event_Changed(this.evento);
  },
  methods: {
    
     checkIfIsMobile() {
      this.isMobile= window.innerWidth < 600;
    },
    async event_Changed(value){
      this.isLoading=true;
       if ( value != null) {
         this.evento.risorse=await this.loadResources(value.idIntervento);
        switch (this.resourcesType) {
          case "Uomo":
            this.loadWorkers();
            break;
          case "Mezzo":
            this.loadVehicles();
            break;
          case "Attrezzatura":
            this.loadEquipment();
            break;
        }
      }
      
      this.isLoading=false;
    },
    loadVehicles() {
      let mezzi = this.evento.risorse.filter((r) => r.tipo == "Mezzo");
      this.resources = mezzi;
    },
    loadEquipment() {
      let attrezzature = this.evento.risorse.filter(
        (r) => r.tipo == "Attrezzatura"
      );
      this.resources = attrezzature;
    },
    loadWorkers() {
      let operatori = this.evento.risorse.filter((r) => r.tipo == "Uomo");
      this.resources = operatori;
    },



    
    async loadResources(eventId) {
      let res = null;
      try {
        console.log("loading resources", eventId);
        res = await EasyPlanClient.Resources.FindByEventId(
          this.$route.params.companyAlias,
          eventId
        );

        console.debug("resources loaded", res);
        // callback(res.data.data);

        return res.data.data;
      } catch (error) {this.handleError(error); }
      return null;
    },
    
    handleError(error) {
      console.log(error);
      this.error = EasyPlanClient.GetErrorDescription(
        error.response.data.errorCode
      );
      console.error(
        "si è verificato un errore (" +
          error.response.data.errorCode +
          ")" +
          this.error
      );
    },
  },
};
</script>

